import { Tabs, Tab } from '@mui/material'
import Container from '@mui/material/Container'
import { useState } from 'react'

import KanseiBreadcrumbs from 'components/breadcrumb'

import DataTransformTab from './components/DataTransformTab'
import HypothesisTab from './components/HypothesisTab'

export default function WorkFlowPage() {
  const links = [{ title: 'ワークフロー' }]
  const [tabIdx, setTabIdx] = useState(0)

  return (
    <Container>
      <KanseiBreadcrumbs links={links} style={{ marginBottom: '15px' }} />
      <Tabs
        value={tabIdx}
        onChange={(_, v) => setTabIdx(v)}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label="データ整形" />
        <Tab label="仮説検証" />
      </Tabs>
      {tabIdx === 0 && <DataTransformTab />}
      {tabIdx === 1 && <HypothesisTab />}
    </Container>
  )
}
